<template>
    <fragment>
        <h1 v-if="size == 1">
            <slot />
        </h1>
        <h2 v-if="size == 2">
            <slot />
        </h2>
        <h3 v-if="size == 3">
            <slot />
        </h3>
        <h4 v-if="size == 4">
            <slot />
        </h4>
        <h5 v-if="size == 5">
            <slot />
        </h5>
        <h6 v-if="size == 6">
            <slot />
        </h6>
    </fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';

export default {
    name: 'Heading',
    components: {
        Fragment,
    },
    props: {
        size: {},
    },
};
</script>

<style scoped>
</style>
